import { useCallback, useState } from "react";
import { POS_STORAGE_KEYS, readStored, writeStored } from "../utils/storage";

const TOP_LIMIT = 12;

/**
 * Counts how often each product is actually sold on this device, which powers
 * the "Top sellers" chip — the shop's real bestsellers end up one tap away
 * without anyone having to curate a list.
 */
export const useFrequentItems = () => {
  const [frequency, setFrequency] = useState(() =>
    readStored(POS_STORAGE_KEYS.frequency, {})
  );

  const recordSale = useCallback((lines) => {
    const next = { ...readStored(POS_STORAGE_KEYS.frequency, {}) };

    lines.forEach((line) => {
      next[line.product.id] = (next[line.product.id] || 0) + line.quantity;
    });

    setFrequency(next);
    writeStored(POS_STORAGE_KEYS.frequency, next);
  }, []);

  const topProducts = useCallback(
    (products) =>
      products
        .filter((product) => frequency[product.id])
        .sort((a, b) => frequency[b.id] - frequency[a.id])
        .slice(0, TOP_LIMIT),
    [frequency]
  );

  return { recordSale, topProducts, hasHistory: Object.keys(frequency).length > 0 };
};
